/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Cancel_TitleInputs */

const vi_carrier_cancel_title = /** @type {(inputs: Carrier_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ vận đơn với hãng?`)
};

/**

* @param {Carrier_Cancel_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_cancel_title = /** @type {((inputs?: Carrier_Cancel_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Cancel_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_cancel_title(inputs)
});